import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface State {
  srPlayerPlayback: boolean;
}

const initialState: State = {
  srPlayerPlayback: false,
};

// T H U N K S

// S L I C E

export const selectorSlice = createSlice({
  name: 'selector',
  initialState,
  reducers: {
    setSrPlayerPlayback: (state, action: PayloadAction<boolean | undefined>) => {
      state.srPlayerPlayback = action.payload ?? !state.srPlayerPlayback;
    },
    resetSelector: () => {
      return initialState;
    },
  },
});

export const { setSrPlayerPlayback, resetSelector } = selectorSlice.actions;

export default selectorSlice.reducer;
